export default __webpack_public_path__ + "c3313b312c53981c0ecc69f2a58551a8.svg";